import clsx from "clsx";
import { imgAvatar } from "@/shared/assets/img";
import InventoryCloseButton from "@/domains/inventory/components/InventoryCloseButton";

type Props = {
  name: string;
  id: number;
  onClose: () => void;
};

export default function InventoryTradeOtherSuggestionHeader({ name, id, onClose }: Props) {
  return (
    <div
      className={clsx(
        "rounded-b-[1rem] px-7.5 h-[4.875rem] w-full",
        "flex items-center gap-1.5 bg-gradient-to-r from-[#368D44]/30 via-transparent to-dark-800/60",
      )}
    >
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center border border-[#84FF97] rounded-[0.625rem] w-[2.75rem] h-[2.75rem] shrink-0">
          <img src={imgAvatar} alt="" className="w-[2.5rem] h-[2.5rem] rounded-[0.5rem]" />
        </div>
        <div className="flex flex-col">
          <div className="text-18 font-bold">{name}</div>
          <div className="text-14 text-[#84FF97] font-medium">#{id}</div>
        </div>
      </div>

      <InventoryCloseButton onClick={onClose} />
    </div>
  );
}
